module.exports = __webpack_public_path__ + "img/asia-admin08.5abcde7b.png";